
import { css } from 'lit';
export default css`
pc-form-block{
  display:block;
}

  pc-form-block pc-form .form-item-sort-by .bef-links ul{
      display:flex;
      column-gap:var(--spacing-6);
      flex-wrap:wrap;
      row-gap:var(--spacing-3);
    }

  pc-form-block pc-form .form-item-sort-by .bef-link{
      font-size:var(--fs-base);
      font-size:var(--bef-link-fs, var(--fs-base));
      font-weight:var(--fw-normal);
      color:var(--neutral-medium-gray);
      padding-bottom:var(--spacing-2);
    }

  pc-form-block pc-form .form-item-sort-by .bef-link:hover,
      pc-form-block pc-form .form-item-sort-by .bef-link:focus{
        color:var(--purple-indigo);
      }

  pc-form-block pc-form .form-item-sort-by .bef-link--selected{
      font-weight:var(--fw-medium);
      color:var(--purple-indigo);
      border-bottom:2px solid var(--purple-indigo);
    }

  pc-form-block pc-form,
  pc-form-block .pc-form{
    --background-color-input:var(--neutral-light);

    --width-input-type-search:50%;
  }

  pc-form-block pc-form .form-item-sort-by{
    margin-top:var(--spacing-3);

  }

pc-form-block[trim]{
  padding-bottom:0px;
}

@media (min-width: 768px){
  pc-form-block{
    --bef-link-fs:var(--fs-lg);
  }
  pc-form-block pc-form .form-item-sort-by{
    position:absolute;
    right:var(--spacing-0);
    transform:translateY(var(--bottom-offset));
    z-index:1;
    margin-top:0;
  }
}
`;